@if (user$ | async; as user) {
  @if (client$ | async; as client) {
    @if (dienstCategorieTaak$ | async; as taak;) {
      @if (algemeneTips$ | async; as algemeneTips) {
        @if (clientTips$ | async; as clientTips) {
          <zah-tips-header
            [client]="client"
            [categorie]="taak.categorie"
            [taak]="taak.taak">
          </zah-tips-header>
          <div class="content">
            <zah-algemene-tips
              [algemeneTips]="algemeneTips"
              [user]="user"
              (algemeneTipAdded)="onAlgemeneTipAdded(taak.dienst, taak.categorie, taak.taak, $event)"
              (algemeneTipEdited)="onAlgemeneTipEdited(taak.categorie, taak.taak, $event)"
              (algemeneTipDeleted)="onAlgemeneTipDeleted(taak.categorie, taak.taak, $event)">
            </zah-algemene-tips>
            <zah-client-tips
              [clientTips]="clientTips"
              [user]="user"
              (clientTipAdded)="onClientTipAdded(client, taak.dienst, taak.categorie, taak.taak, $event)"
              (clientTipEdited)="onClientTipEdited(client, taak.categorie, taak.taak, $event)"
              (clientTipDeleted)="onClientTipDeleted(client, taak.categorie, taak.taak, $event)">
            </zah-client-tips>
            <button mat-mini-fab
              color="primary"
              class="back-button"
              (click)="navigateBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </div>
        }
      }
    }
  }
}
